// extracted by mini-css-extract-plugin
export default {"head":"order-page-parts_head__LxgBh","cell":"order-page-parts_cell__IaUSO","label":"order-page-parts_label__CWGXU","row":"order-page-parts_row__deeFn"};